export const ASSET_URI_TOOLTIP_ITEMS = [
  {
    title: 'Enterprise',
    content:
      '기업 단위의 최상위 식별 계층으로, 전체 자산 체계의 소유 주체를 정의하며 다수의 Site를 포괄하는 논리적·조직적 범위를 의미',
  },
  {
    title: 'Site',
    content:
      '기업 산하의 물리적 운영 거점으로, 공장·플랜트·사업장 등 지리적 위치 또는 독립된 생산 단위를 나타내며 Area의 상위 개념',
  },
  {
    title: 'Area',
    content:
      'Site 내에서 기능적으로 구분된 생산 영역 또는 제조 라인 단위로, 특정 제품군 또는 공정 흐름 기준으로 구성되는 운영 단위',
  },
  {
    title: 'Process',
    content:
      'Area 내에서 수행되는 세부 제조 단계 또는 작업 흐름을 정의하며, 공정 단위의 로직·순서·기능적 역할을 포함하는 실행 단위',
  },
  {
    title: 'Unit',
    content:
      'Process를 구성하는 물리적 설비 또는 장비 단위로, 실제 공정을 수행하는 기능적 실행 주체이며 센서·제어·운영 데이터의 주요 발생 지점',
  },
  {
    title: 'Component',
    content:
      'Unit을 구성하는 하위 물리 요소(부품)로, 설비의 기능을 세분화한 최소 관리 단위이며 고장 진단, 유지보수, 상태 모니터링의 기준 객체',
  },
] as const;
